import { IconButton } from '@mui/material'
import { MouseEventHandler, ReactElement } from 'react'

interface ScrollToButtonProps {
  referenceId: string
  icon: ReactElement
}

export const ScrollToButton = ({ referenceId, icon }: ScrollToButtonProps) => {
  const handleOpen: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()

    const targetSection = document.getElementById(referenceId)
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return <IconButton onClick={handleOpen}>{icon}</IconButton>
}
